// React imports
import React from 'react';

// React based imports
import { Switch, Route, Redirect } from 'react-router-dom';

// Third-party imports

// Project file imports
import Dashboard from './Pages/dashboard';
import Login from './Pages/login';
import { isLoggedIn } from './Pages/login/login.service';

const authGuard = (component: any) => {
    return isLoggedIn() ? component : <Redirect to="/login" />
}

export default () => {
    return (
        <Switch>
            <Route path="/" exact       render={() => authGuard(<Redirect to="/dashboard" />) } />
            <Route path="/dashboard"    render={(props) => authGuard(<Dashboard {...props}/>)} />
            <Route path="/login"        component={Login} />
        </Switch>
    );
}